import { defineMessage } from '@lingui/macro';

const SCHEDULED = 'SCHEDULED',
  IN_PROGRESS = 'IN PROGRESS',
  COMPLETED = 'COMPLETED',
  ERRORED = 'ERRORED',
  CANCELLED = 'CANCELLED',
  NOT_STARTED = 'NOT_STARTED';

export const ImportStatusCodeMessages = {
  [SCHEDULED]: defineMessage({ message: `SCHEDULED` }),
  [IN_PROGRESS]: defineMessage({ message: `IN PROGRESS` }),
  [COMPLETED]: defineMessage({ message: `COMPLETED` }),
  [ERRORED]: defineMessage({ message: `ERRORED` }),
  [CANCELLED]: defineMessage({ message: `CANCELLED` }),
  [NOT_STARTED]: defineMessage({ message: `NOT STARTED` }),
};
